import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo/Logo";

export default function NotFoundPage() {
  return (
    <div className="not-found" data-testid="not-found">
      <Logo size={48} variant="default" />
      <div className="not-found-num">404</div>
      <h1 className="h-display" style={{ fontSize: 32 }}>
        Página não encontrada.
      </h1>
      <p className="body" style={{ color: "var(--color-text-muted)" }}>
        O que você procura pode estar por aqui.
      </p>
      <Link to="/" className="btn btn-primary" data-testid="not-found-cta">
        Voltar ao início
      </Link>
    </div>
  );
}
